import { useMemo } from 'react';

export function useEnvironment() {
  const environment = useMemo(() => {
    const mode = import.meta.env.MODE;
    const isProduction = mode === 'production';
    const isDevelopment = mode === 'development';
    const isStaging =
      import.meta.env.VITE_API_BASE_URL?.includes('staging') ||
      mode === 'staging';

    return {
      mode,
      isProduction,
      isDevelopment,
      isStaging,
      isTest: mode === 'test',
    };
  }, []);

  return environment;
}
